import { render, staticRenderFns } from "./slideBarStarter.vue?vue&type=template&id=46510272"
import script from "./slideBarStarter.js?vue&type=script&lang=js&external"
export * from "./slideBarStarter.js?vue&type=script&lang=js&external"
import style0 from "./slideBarStarter.vue?vue&type=style&index=0&id=46510272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports